module.exports = __webpack_public_path__ + "static/media/videocam-off.62fdc105.svg";